<script setup lang="ts">
import type { ConvinientProps } from '.';
import type { ButtonProps } from '~/components/ui/button/';
import type { PropertyFilters } from '~/core/entities/property/filters';

const props = defineProps<ConvinientProps>();

const modelValue = defineModel<
	PropertyFilters['bedrooms' | 'suites' | 'bathrooms' | 'parkingSpots']
>({
	default: 0
});

const convinientsEnum: Record<string, string> = {
	bedrooms: 'Quartos',
	bathrooms: 'Banheiros',
	suites: 'Suítes',
	parkingSpots: 'Vagas'
};

const options: number[] = [0, 1, 2, 3, 4, 5];
const optionsPrefix: string = '+';

function select(option: number): void {
	modelValue.value = modelValue.value === option ? 0 : option;
}

function getVariant(option: number): ButtonProps['variant'] {
	return modelValue.value === option ? 'primary' : 'tertiary';
}

function getLabel(option: number) {
	return option === 0 ? 'Qualquer' : `${optionsPrefix}${option}`;
}
</script>

<template>
	<div class="space-y-2">
		<p class="text-base font-normal leading-normal text-primary">
			{{ convinientsEnum[props.convinient] }}
		</p>
		<div class="flex items-center gap-2">
			<Button
				v-for="option in options"
				:key="`convinient-select-option-${option}`"
				:variant="getVariant(option)"
				size="sm"
				class="px-3"
				@click="select(option)"
			>
				{{ getLabel(option) }}
			</Button>
		</div>
	</div>
</template>
